
























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Template, TemplateField } from '@/models/template';
import { Base } from '@/components/common/base';
import { templateService } from '@/shared';
import { ValidationRules } from '@/helper/enum';
import { TemplateAssociationType } from '@/enums/enums';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class TemplatePage extends Base {
  public template: Template = {
    associatedWith: [],
    name: '',
    text: '',
  };
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public templateFields: TemplateField[] = [];
  public disableSubmitButton: boolean = false;
  public associationList: any[] = [];


  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({ name: 'admin.templates' });
    } else if (methodName === 'submitTemplate') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('templates.alertInvalidFrom'));
        this.resetMethodName(methodName);
        return;
      }
      this.submitTemplate();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('templates.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('templates.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'templates');

    // Toolbar
    this.updateToolBar();
    this.getTemplateAssociation();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });



    this.formFields = [
      {
        key: 'associatedWith',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: 'Associated With',
          required: true,
          disabled: false,
          items: this.associationList,
          loading: false,
          text: 'value',
          value: 'key',
          multiple: true,
          altag: 'Associated With',
          rules: [
            v => this.requiredForArray('Associated With', v)
          ],
        },
      },
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$t('templates.templateFields.name') as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [(v) => this.required('Name', v)],
        },
      },
      {
        key: 'text',
        type: 'v-alynk-textarea',
        required: true,
        templateOptions: {
          counter: 5000,
          label: this.$t('templates.templateFields.description') as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [(v) => this.required('Description', v)],
          elementClass: 'mt-5',
        },
      },
    ];

    if (this.$route.params.id) {
      try {
        this.formlyShowSkeleton(this.formFields);
        const response = await templateService.getTemplate(
          this.$route.params.id
        );
        this.template = response;
      } finally {
        this.formlyHideSkeleton(this.formFields);
      }
    }

    this.getTemplateFields();
  }

  public async getTemplateAssociation() {
    for (let item in TemplateAssociationType) {
      this.associationList.push({ key: item, value: item });
    }
  }

  public validateTemplate(): Vue & { validate: () => boolean } {
    return this.$refs.templateForm as Vue & { validate: () => boolean };
  }
  public async submitTemplate(): Promise<void> {
    if (this.validateTemplate().validate()) {
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        if (this.$route.params.id) {
          await templateService.updateTemplate(this.template);
          this.showAlert(true, this.$t('templates.alertUpdateTemplate'));
          this.$router.push({ name: 'admin.templates' });
        } else {
          await templateService.saveTemplate(this.template);
          this.showAlert(true, this.$t('templates.alertSaveTemplate'));
          this.$router.push({ name: 'admin.templates' });
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }
  public async getTemplateFields(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const response = await templateService.getTemplateFields();
      this.templateFields = response.results;
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }
  public appendField(field: string): void {
    this.template.text += `{${field}}`;
  }
}
